import * as yup from 'yup';
import { ngnRegistrationNumberRegex, numberRegex, urlRegex } from '../constant';

const businessInfoSchema = yup.object().shape({
  email: yup
    .string().trim()
    .email('Enter a valid email')
    .required('Email is required'),
  description: yup
    .string()
    .required('Description is required')
    .max(1000, 'Description cannot be more than 20 characters'),
  website: yup
    .string()
    .nullable()
    .test(
      'is-correct-url',
      'Must be a valid URL',
      (value) => !value || urlRegex.test(value),
    ),

  registrationNumber: yup
    .string()
    .required('Registration number is required')
    .test(
      'is-correct-business-name',
      'Must start with BC- or RC- followed by a 7 digit number',
      (value) => !!value && ngnRegistrationNumberRegex.test(value),
    ),
  businessType: yup.string().required('Business type is required'),
  country: yup.string().required('Country is required'),
});

const businessAddressSchema = yup.object().shape({
  streetLine1: yup.string().required('Address line 1 is required'),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  postalCode: yup
    .string()
    .length(6, 'Postal code must be at least 6 characters')
    .matches(numberRegex, 'Postal code must contain only numbers')
    .required('Postal code is required'),
  countryCode: yup.string().required('Country is required'),
});

const ultimateBeneficiarySchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  birthDate: yup
    .date()
    .typeError('Invalid date format')
    .required('Date of birth is required'),
  email: yup
    .string().trim()
    .email('Enter a valid email')
    .required('Email is required'),
  phone: yup.string().required('Phone number is required'),
  streetLine1: yup.string().required('Address line 1 is required'),
  streetLine2: yup.string().nullable(), // optional
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  postalCode: yup
    .string()
    .matches(numberRegex, 'Postal code must contain only numbers')
    .length(6, 'Postal code must be 6 characters')
    .required('Postal code is required'),
  countryCode: yup.string().required('Country is required'),
  identityNumberType: yup.string().required('ID number type is required'),
  identityNumber: yup.string().required('ID number is required'),
  identityDocumentType: yup.string().required('Document type is required'),
});

const onboardingValidationSchemas = [
  businessInfoSchema,
  businessAddressSchema,
  ultimateBeneficiarySchema,
];

export default onboardingValidationSchemas;
